import {
  ACTION_INVENTORY_START,
  SEARCH_INVENTORY,
  SEARCH_INVENTORY_DETAIL,
  INVENTORY_LOG_COUNT,
  UPDATE_INVENTORY_STATE,
  GET_AUDIT_TRAIL,
  GET_DRIVER_STATUS,
  GET_INVENTORY_COUNT,
  CANCEL_DRIVER_REQUEST,
  CAR_MOVEMENT,
  SLOT_PREFERENCE_SAVED,
  ACTION_INVENTORY_END,
  CHANGE_INVENTORY_STATE_LOCAL,
  CHANGE_CAR_MOVEMENT_STATUS_LOCAL,
  SLOT_PREFERENCE_SAVED_LOCAL,
  CHANGE_DRIVER_RETURN_STATUS,
  CHANGE_PARKING_SLOT_LOCAL,
  CHANGE_LIST_PRICING,
  CHANGE_LIST_PRICING_LOCAL,
  CHANGE_TARGET_PRICE,
  CHANGE_TARGET_PRICE_LOCAL,
  CHANGE_PUBLISH_STATUS,
  CHANGE_PUBLISH_STATUS_LOCAL,
  SAVED_UPLOAD_FILE,
  LOGISTIC_MOVEMENT,
  LOGISTIC_MOVEMENT_LOCAL,
  ACTION_EXPORT_CSV,
  BULK_UPLOAD_STATUS,
  BULK_UPLOAD_STATUS_DETAILS,
  BULK_UPLOAD_STATUS_COUNT,
  REFESH_PAGE,
  UI_RULES,
  INSPECTION_DATA,
  ADDRESS_FILL,
  ADDRESS_FILL_START,
  ADDRESS_FILL_FAIL,
  UPDATE_PARKING_SLOT,
  UPDATE_INVENTORY_STAGE,
  CHANGE_INVENTORY_STAGE_LOCAL,
  UPDATE_INVENTORY_TYPE,
  CHANGE_INVENTORY_TYPE_LOCAL,
  POST_INSPECTION_DATA,
  CHANGE_EGC_VALUE,
  CHANGE_EGC_VALUE_LOCAL,
  SEARCH_INSPECTION_DETAIL,
  CHANGE_RESERVE_STATUS_LOCAL,
  CHANGE_RESERVE_STATUS,
  GET_TEAMS,
  GET_EXTERNAL_DELIVERY_ALLOWED,
  GET_PAYMENT_DETAILS,
  ACTION_APT_ORDERS_START,
  ACTION_APT_ORDERS_END,
  ACTION_APT_ORDERS,
  GET_LOCUS_TEAMS,
  ACTION_INVENTORY_ASSETS,
  DOCUMENT_PENDENCY_START,
  DOCUMENT_PENDENCY_END,
  DOCUMENT_PENDENCY_SEARCH,
  GET_CONTACT_PERSONS,
  FETCH_FIELD_AUDIT_HISTORY,
  SUCCESS_FIELD_AUDIT_HISTORY,
  ERROR_FIELD_AUDIT_HISTORY,
  UPDATE_SELECTED_INVENTORIES,
  INVENTORY_ORDERS_SUCCESS,
  CHANGE_PARENT_HUB,
  CHANGE_PARENT_HUB_LOCAL,
  CHANGE_NUMBER_PLATE_LOCAL,
  CHANGE_NUMBER_PLATE,
} from './inventoryManagement.actiontype';
import axiosService from '../../../inits/axios';
import { convertObjectToParams } from '../../../utils/utils';
import { config } from '../../../utils/constants/api.constants';
import { setToasterMessage } from '../commonAction/common.action';
import {
  AdditionalInventoryState,
  InventoryStatus,
  AlertType,
  BULK_ACTION,
  MAX_BULK_ACTION_ALLOWED,
} from '../../../utils/constants/values.constants';
import { auditHistoryService, InventoryService } from '../../../services';

export const getTeams =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/logistic/locus/teams' +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_TEAMS, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Could not fetch the teams',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const searchInventory =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: SEARCH_INVENTORY, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: false,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const updateSelectedInventories =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: UPDATE_SELECTED_INVENTORIES, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const searchDocumentPendency =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: DOCUMENT_PENDENCY_START });

    const url =
      config.api.inventory.host +
      '/api/inventory/asset/search' +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);
      dispatch({ type: DOCUMENT_PENDENCY_SEARCH, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: DOCUMENT_PENDENCY_END });
    }
  };

export const uploadInventoryFile = (body) => async (dispatch) => {
  let newbody = body.bulkData;
  var formData = new FormData();
  formData.append('file', newbody.file);
  formData.append('uploadType', newbody.uploadType);

  dispatch({ type: ACTION_INVENTORY_START });
  const url = config.api.inventory.bulkHost + config.api.inventory.upload;

  try {
    const data = await axiosService.post(url, formData);
    dispatch(
      setToasterMessage({
        toasterMessage:
          'File Upload was successful. Request id: ' + data.data.id,
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({
      type: SAVED_UPLOAD_FILE,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e.response.status === 500 || e.response.data)
      dispatch(
        setToasterMessage({
          toasterMessage:
            e.response.status === 500
              ? e.response.data.message
              : e.response.data && e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    dispatch({ type: ACTION_INVENTORY_END });
  }
};

export const bulkUploadByType = (body) => async (dispatch) => {
  const newbody = body.bulkData;
  const formData = new FormData();

  formData.append('file', newbody.file);
  formData.append('uploadType', newbody.uploadType);

  dispatch({ type: ACTION_INVENTORY_START });

  const url = config.api.inventory.bulkHost + config.api.inventory.upload;

  try {
    const data = await axiosService.post(url, formData);

    dispatch(
      setToasterMessage({
        toasterMessage:
          'File upload was successful. Request ID: ' + data.data.id,
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
    dispatch({
      type: SAVED_UPLOAD_FILE,
      payload: data.data ? data.data : 'success',
    });
  } catch (e) {
    if (e.response.status === 500 || e.response.data)
      dispatch(
        setToasterMessage({
          toasterMessage:
            e.response.status === 500
              ? e.response.data.message
              : e.response.data && e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    dispatch({ type: ACTION_INVENTORY_END });
  }
};

export const searchInspectionDetails =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/apt-' +
      params.appointmentId +
      config.api.inventory.inspectionDetails;

    try {
      const data = await axiosService.get(url);

      dispatch({ type: SEARCH_INSPECTION_DETAIL, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const getPaymentStatus =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/apt-' +
      params.appointmentId +
      config.api.inventory.paymentStatus;

    try {
      const data = await axiosService.get(url);

      dispatch({ type: GET_PAYMENT_DETAILS, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const searchInventoryDetail =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      config.api.inventory.v2 +
      '/apt-' +
      params.appointmentId;

    try {
      const data = await axiosService.get(url);
      dispatch({ type: SEARCH_INVENTORY_DETAIL, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const searchInventoryAssets =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventoryAsset +
      '/apt-' +
      params.appointmentId +
      '/' +
      params.type;

    try {
      const data = await axiosService.get(url);
      dispatch({ type: ACTION_INVENTORY_ASSETS, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const getAuditTrail =
  (params = {}, id) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    let url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.auditTrail +
      config.api.inventory.inventory +
      '/' +
      id +
      convertObjectToParams(params);
    if (params && params.entity === 'InventoryMovement') {
      url =
        config.api.inventory.host +
        config.api.inventory.api_version +
        config.api.inventory.auditTrail +
        config.api.inventory.inventoryMovement +
        '/' +
        id +
        convertObjectToParams(params);
    }

    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_AUDIT_TRAIL, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const getDriverStatus =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      params +
      config.api.inventory.movement;

    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_DRIVER_STATUS, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const getAddress =
  (appointmentId, params = {}) =>
  async (dispatch) => {
    dispatch({ type: ADDRESS_FILL_START });
    const {
      oms: { host, order, latest },
      masterdata: { api_v1 },
    } = config.api;

    let url = `${host}${api_v1}${order}${appointmentId}${latest}${convertObjectToParams(
      params
    )}`;

    try {
      const data = await axiosService.get(url);
      dispatch({ type: ADDRESS_FILL, payload: data.data });
    } catch (e) {
      dispatch({ type: ADDRESS_FILL_FAIL });
    }
  };

export const getInventoryCount =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      config.api.inventory.inventoryCount +
      convertObjectToParams(params);
    try {
      const data = await axiosService.get(url);
      dispatch({ type: GET_INVENTORY_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const exportCSV = () => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    config.api.inventory.exportCSV;

  try {
    const data = await axiosService.get(url);

    dispatch({ type: ACTION_EXPORT_CSV, payload: data.data });
  } catch (e) {
    console.error('Error::', e);
    dispatch({ type: ACTION_INVENTORY_END });
  }
};

export const getInventoryLogCount =
  (params = {}, id) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.auditTrail +
      config.api.inventory.inventoryCount +
      '/' +
      id +
      convertObjectToParams(params);

    try {
      const data = await axiosService.get(url);

      dispatch({ type: INVENTORY_LOG_COUNT, payload: data.data });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const getAppointmentOrders = (appointmentId) => async (dispatch) => {
  dispatch({ type: ACTION_APT_ORDERS_START });
  let { host, api_version, inventory } = config.api.inventory;
  const url = `${host}${api_version}${inventory}/apt-${appointmentId}/bookedOrder`;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: ACTION_APT_ORDERS, payload: data.data });
  } catch {
    dispatch({ type: ACTION_APT_ORDERS_END });
  }
};

export const cancelDreiverRequest =
  (params = {}, id) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      id +
      config.api.inventory.movement +
      convertObjectToParams(params);

    try {
      const data = await axiosService.put(url);

      dispatch({
        type: CANCEL_DRIVER_REQUEST,
        payload: data.data ? data.data : 'success',
      });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });

      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch({ type: ACTION_INVENTORY_END });
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const updateInventoryState =
  (params, id, rawData = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      id +
      convertObjectToParams(params);

    let data;
    try {
      data = await axiosService.post(url, rawData);
      dispatch({
        type: UPDATE_INVENTORY_STATE,
        payload: data.data ? data.data : { message: 'success', params: params },
      });
      let toasterMessage = '';
      if (params && params.action) {
        if (params.action === AdditionalInventoryState[0]) {
          toasterMessage = 'Trip has been ended.';
        } else if (params.action === AdditionalInventoryState[1]) {
          toasterMessage = 'Trip has been started.';
        } else if (params.action === Object.keys(InventoryStatus)[1]) {
          toasterMessage = 'Inventory Stocked in successfully.';
        } else if (params.action === Object.keys(InventoryStatus)[2]) {
          toasterMessage = 'Inventory Stocked out successfully.';
        } else if (params.action === 'RETURN') {
          toasterMessage = 'Inventory returned successfully.';
        }
        dispatch(
          setToasterMessage({
            toasterMessage: toasterMessage,
            showToaster: true,
            toasterType: AlertType.SUCCESS,
          })
        );
      }
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const refreshLogistic =
  ({ id }) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      id +
      config.api.inventory.movement +
      '/refresh';
    try {
      const data = await axiosService.put(url);
      dispatch({ type: REFESH_PAGE, payload: data });
      window.location?.reload(true);
      dispatch(
        setToasterMessage({
          toasterMessage: 'Refresh successfully.',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch({ type: ACTION_INVENTORY_END });
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const carMovement = (body, id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    '/' +
    id +
    config.api.inventory.movement;
  try {
    const data = await axiosService.post(url, body);
    dispatch({
      type: CAR_MOVEMENT,
      payload: data.data ? data.data : 'success',
    });
    dispatch(
      setToasterMessage({
        toasterMessage: 'Pickup request created successfully.',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
  } catch (e) {
    dispatch({ type: ACTION_INVENTORY_END });
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const updateMovementWithoutCancelling =
  (body, appointmentId, movementId) => async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/apt-' +
      appointmentId +
      '/' +
      movementId +
      '/update';
    try {
      const data = await axiosService.put(url, body);
      dispatch({
        type: CAR_MOVEMENT,
        payload: data.data ? data.data : 'success',
      });
      dispatch(
        setToasterMessage({
          toasterMessage: 'Pickup request updated successfully.',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch({ type: ACTION_INVENTORY_END });
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const updateMovement = (body, id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });

  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    '/' +
    id +
    config.api.inventory.updateMovement;

  try {
    const data = await axiosService.put(url, body);
    dispatch({
      type: CAR_MOVEMENT,
      payload: data.data ? data.data : 'success',
    });
    dispatch(
      setToasterMessage({
        toasterMessage: 'Pickup request updated successfully.',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
  } catch (e) {
    dispatch({ type: ACTION_INVENTORY_END });
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const updateMovementDetails = (body, id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });

  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    '/' +
    id +
    config.api.inventory.updateMovementDetails;

  try {
    await axiosService.put(url, body);

    dispatch({ type: UPDATE_INVENTORY_STATE, payload: { message: 'success' } });
    dispatch(
      setToasterMessage({
        toasterMessage: 'Movement details updated successfully.',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
  } catch (e) {
    dispatch({ type: ACTION_INVENTORY_END });
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const saveSlotPreference = (body, id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });

  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    '/' +
    'apt-' +
    id +
    '/reschedule?tags=RESCHEDULED_INTERNAL';

  try {
    const data = await axiosService.put(url, body);
    dispatch({
      type: SLOT_PREFERENCE_SAVED,
      payload: data.data ? data.data : 'success',
    });
    dispatch(
      setToasterMessage({
        toasterMessage: 'Slot preference saved successfully.',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
  } catch (e) {
    dispatch({ type: ACTION_INVENTORY_END });
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const logisticMovement = (body, id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    '/' +
    id +
    config.api.inventory.logistic;
  try {
    const data = await axiosService.post(url, body);
    dispatch({
      type: LOGISTIC_MOVEMENT,
      payload: data.data ? data.data : 'success',
    });
    dispatch(
      setToasterMessage({
        toasterMessage: 'Logistic vendor set successfully.',
        showToaster: true,
        toasterType: AlertType.SUCCESS,
      })
    );
  } catch (e) {
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    } else {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Internal Server Error',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
    dispatch({ type: ACTION_INVENTORY_END });
  }
};

export const getStatus = (page, size) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  const {
    api: {
      inventory: { status, bulkHost },
    },
  } = config;
  const url = bulkHost + status + `?page=${page}&size=${size}`;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: BULK_UPLOAD_STATUS, payload: data.data });
    dispatch({ type: ACTION_INVENTORY_END });
  } catch (e) {
    console.error(e);
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const uiRules = () => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });

  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.config +
    config.api.inventory.ui_rules;

  try {
    const data = await axiosService.get(url);
    dispatch({ type: UI_RULES, payload: data.data });
  } catch (e) {
    dispatch({ type: ACTION_INVENTORY_END });
  }
};

export const getTotalStatusCount = (id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  const {
    api: {
      inventory: { bulkHost, statusCount },
    },
  } = config;
  const qId = id ? `/${id}` : '';

  const url = bulkHost + statusCount + qId;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: BULK_UPLOAD_STATUS_COUNT, payload: data.data });
    dispatch({ type: ACTION_INVENTORY_END });
  } catch (e) {
    console.error(e);
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const getStatusDetails = (id, page, size) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  dispatch({ type: BULK_UPLOAD_STATUS_DETAILS, payload: [] });
  const {
    api: {
      inventory: { status, bulkHost },
    },
  } = config;
  const url = bulkHost + status + '/' + id + `?page=${page}&size=${size}`;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: BULK_UPLOAD_STATUS_DETAILS, payload: data.data });
    dispatch({ type: ACTION_INVENTORY_END });
  } catch (e) {
    console.error(e);
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const getLocusTeams = () => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });

  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.locus_teams;

  try {
    const data = await axiosService.get(url);
    dispatch({ type: GET_LOCUS_TEAMS, payload: data.data });
    dispatch({ type: ACTION_INVENTORY_END });
  } catch (e) {
    dispatch(
      setToasterMessage({
        toasterMessage: 'Something went wrong, please try again later.',
        showToaster: true,
        toasterType: AlertType.ERROR,
      })
    );
    dispatch({ type: ACTION_INVENTORY_END });
  }
};

export const changePricing =
  (params = {}, rawBody = {}, id) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/apt-' +
      id +
      convertObjectToParams(params);

    try {
      const data = await axiosService.post(url, rawBody);
      dispatch({
        type: CHANGE_LIST_PRICING,
        payload: data.data ? data.data : { message: 'success', params: params },
      });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changePricingStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_LIST_PRICING_LOCAL });
};

export const changeTargetPrice =
  (params = {}, rawData = {}, id) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/apt-' +
      id +
      convertObjectToParams(params);

    try {
      const data = await axiosService.post(url, rawData);
      dispatch({
        type: CHANGE_TARGET_PRICE,
        payload: data.data ? data.data : { message: 'success', params: params },
      });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });

      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changeTargetPriceStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_TARGET_PRICE_LOCAL });
};

export const changeEGCValue =
  (appointmentId, params = {}, rawData = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    try {
      await InventoryService.updateInventoryAttributes(
        'post',
        appointmentId,
        rawData,
        params
      );

      dispatch({
        type: CHANGE_EGC_VALUE,
        payload: { message: 'success' },
      });

      dispatch(
        setToasterMessage({
          toasterMessage: 'EGC updated successfully',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });

      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changeEGCValueStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_EGC_VALUE_LOCAL });
};

export const changeParkingSlot =
  (params, id, rawData = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      id +
      convertObjectToParams(params);

    try {
      const data = await axiosService.post(url, rawData);

      dispatch({
        type: UPDATE_PARKING_SLOT,
        payload: data.data ? data.data : { message: 'success' },
      });
      dispatch(
        setToasterMessage({
          toasterMessage: 'Parking Slot Updated',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });

      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changeInventoryStage =
  (params, id, rawData = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      id +
      convertObjectToParams(params);

    try {
      const data = await axiosService.post(url, rawData);

      dispatch({
        type: UPDATE_INVENTORY_STAGE,
        payload: data.data ? data.data : { message: 'success' },
      });
      dispatch(
        setToasterMessage({
          toasterMessage: 'Inventory Stage Updated',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });

      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changeGpsTrackerNumber =
  (params, id, rawData = {}, callback) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      id +
      convertObjectToParams(params);

    try {
      await axiosService.post(url, rawData);
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage: 'GPS tracker number updated',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
      callback();
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });

      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changeInventoryType =
  (params, id, rawData = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      id +
      convertObjectToParams(params);

    try {
      const data = await axiosService.post(url, rawData);

      dispatch({
        type: UPDATE_INVENTORY_TYPE,
        payload: data.data ? data.data : { message: 'success' },
      });
      dispatch(
        setToasterMessage({
          toasterMessage: 'Inventory type updated',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });

      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changePublishStatus =
  (params = {}, id, rawData = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/apt-' +
      id +
      convertObjectToParams(params);

    try {
      const response = await axiosService.post(url, rawData);

      dispatch({
        type: CHANGE_PUBLISH_STATUS,
        payload: { message: 'success', params: params },
      });
      dispatch(
        setToasterMessage({
          toasterMessage: response?.data,
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch({ type: ACTION_INVENTORY_END });
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const changeReserveStatus =
  (params = {}, id) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      `/apt-${id}?action=UPDATE_RESERVE_STATUS`;

    try {
      await axiosService.post(url, params);

      dispatch({
        type: CHANGE_RESERVE_STATUS,
        payload: { message: 'success', params: params },
      });
      dispatch(
        setToasterMessage({
          toasterMessage: params.reserveStatus
            ? 'Reserved Successfully.'
            : 'Unreserved Successfully.',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
    } catch (e) {
      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch({ type: ACTION_INVENTORY_END });
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const getCatelogFlagFromInspection =
  (appointmentId, inspectionType = 'POST_REFURB') =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    const url = `${config.api.inspection.host}${config.api.inspection.inspection}/${appointmentId}?inspectionType=${inspectionType}`;
    try {
      const data = await axiosService.get(url);
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch({ type: INSPECTION_DATA, payload: data.data });
    } catch (error) {
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const getPostInspection = (id) => async (dispatch) => {
  dispatch({ type: POST_INSPECTION_DATA });
  const url = `${config.api.inspection.host}${config.api.inspection.inspection}/${id}`;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: POST_INSPECTION_DATA, payload: data.data });
  } catch (error) {
    console.error('Error:', error && error.response);
  }
};

export const getExternalDeliveryAllowed =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/' +
      params.appointmentId +
      '/externalDeliveryAllowed';

    try {
      const data = await axiosService.get(url);

      dispatch({ type: GET_EXTERNAL_DELIVERY_ALLOWED, payload: data.data });
    } catch (e) {
      dispatch(
        setToasterMessage({
          toasterMessage: 'Something went wrong, please try again later.',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    }
  };

export const getContactPersons = () => async (dispatch) => {
  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.config +
    config.api.inventory.contactPersons;
  try {
    const data = await axiosService.get(url);
    dispatch({ type: GET_CONTACT_PERSONS, payload: data.data });
  } catch (e) {
    console.log(e);
  }
};

export const changeInventoryStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_INVENTORY_STATE_LOCAL });
};

export const changeCarMovementStatusLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_CAR_MOVEMENT_STATUS_LOCAL });
};

export const slotPreferenceSavedLocal = () => async (dispatch) => {
  dispatch({ type: SLOT_PREFERENCE_SAVED_LOCAL });
};

export const changeLogisticMovementStatusLocal = () => async (dispatch) => {
  dispatch({ type: LOGISTIC_MOVEMENT_LOCAL });
};

export const changeDriverStatusLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_DRIVER_RETURN_STATUS });
};

export const changeParkingSlotStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_PARKING_SLOT_LOCAL });
};

export const changeInventoryStageStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_INVENTORY_STAGE_LOCAL });
};

export const changeInventoryTypeStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_INVENTORY_TYPE_LOCAL });
};

export const changePublishStatusLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_PUBLISH_STATUS_LOCAL });
};

export const changeReserveStatusLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_RESERVE_STATUS_LOCAL });
};

export const changeParentHubStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_PARENT_HUB_LOCAL });
};

export const changeNumberPlateStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_NUMBER_PLATE_LOCAL });
};

export const getInventoryFieldAuditHistory =
  (inventoryId, params) => async (dispatch) => {
    dispatch({ type: FETCH_FIELD_AUDIT_HISTORY });

    try {
      const data = await auditHistoryService.getInventoryFieldHistoryV2(
        inventoryId,
        params
      );
      dispatch({ type: SUCCESS_FIELD_AUDIT_HISTORY, payload: data });
    } catch (e) {
      dispatch({ type: ERROR_FIELD_AUDIT_HISTORY });

      if (e.response.status === 500 || e.response.data) {
        dispatch(
          setToasterMessage({
            toasterMessage:
              e.response.status === 500
                ? e.response.data.message
                : e.response.data && e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const sourcingCancellation =
  (appointmentId, params, rawData = {}, callback) =>
  async (dispatch) => {
    const { host, api_version, inventory } = config.api.inventory;
    const url = `${host}${api_version}${inventory}/apt-${appointmentId}${convertObjectToParams(
      params
    )}`;

    dispatch({ type: ACTION_INVENTORY_START });

    try {
      await axiosService.post(url, rawData);
      dispatch(
        setToasterMessage({
          toasterMessage: 'Sourcing cancellation successful',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
      callback();
      dispatch({ type: ACTION_INVENTORY_END });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
      if (e && e.response && e.response.data && e.response.data.message) {
        dispatch({ type: ACTION_INVENTORY_END });
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message,
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      }
    }
  };

export const bulkActionMovement =
  (bulkActionType, params, rawData = {}, callback) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    let bulkActionPromise;

    switch (bulkActionType) {
      case BULK_ACTION.CREATE_PICKUP_REQUEST:
        bulkActionPromise = InventoryService.bulkInternalMovement(
          params,
          rawData
        );
        break;
      case BULK_ACTION.SET_LOGISTIC_VENDOR:
        bulkActionPromise = InventoryService.bulkSetLogisticVendor(
          params,
          rawData
        );
        break;
      case BULK_ACTION.MOVE_OUT:
      case BULK_ACTION.PARK:
        bulkActionPromise = InventoryService.bulkMoveOutAndPark(
          params,
          rawData
        );
        break;
    }

    bulkActionPromise
      .then((data) => {
        if (Array.isArray(data) && !data.length) {
          dispatch(
            setToasterMessage({
              toasterMessage: 'Bulk action completed successfully',
              showToaster: true,
              toasterType: AlertType.SUCCESS,
            })
          );
        } else {
          //Show generic bulk action error message
          const genericError = data?.find((d) => d.id == '0')?.errorMsg;

          if (genericError) {
            dispatch(
              setToasterMessage({
                toasterMessage: genericError,
                showToaster: true,
                toasterType: AlertType.ERROR,
              })
            );
          }
        }
        //Send back appointmentId specific errors
        let errorRows = data?.filter((d) => d.id != '0') || [];
        callback(errorRows);
      })
      .catch(() => {
        dispatch(
          setToasterMessage({
            toasterMessage: 'Something went wrong, please try again later',
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      })
      .finally(() => {
        dispatch({ type: ACTION_INVENTORY_END });
      });
  };

export const bulkSendVendorAssignedEmail =
  (params, callback, isBulkTrigger = true) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    InventoryService.bulkSendVendorAssignedEmail(params)
      .then((data) => {
        if (Array.isArray(data) && !data.length) {
          dispatch(
            setToasterMessage({
              toasterMessage: 'Email sent to the vendor successfully',
              showToaster: true,
              toasterType: AlertType.SUCCESS,
            })
          );
        } else {
          //Show generic bulk email error message
          const genericError = data?.find((d) => d.id == '0')?.errorMsg;

          if (genericError) {
            dispatch(
              setToasterMessage({
                toasterMessage: genericError,
                showToaster: true,
                toasterType: AlertType.ERROR,
              })
            );
          }
        }
        //Send back appointmentId specific errors
        let errorRows = data?.filter((d) => d.id != '0') || [];
        callback(errorRows);

        //Show error as a toast when email triggered from inventory details
        if (!isBulkTrigger) {
          dispatch(
            setToasterMessage({
              toasterMessage: errorRows[0].errorMsg,
              showToaster: true,
              toasterType: AlertType.ERROR,
            })
          );
        }
      })
      .catch(() => {
        dispatch(
          setToasterMessage({
            toasterMessage: 'Something went wrong, please try again later',
            showToaster: true,
            toasterType: AlertType.ERROR,
          })
        );
      })
      .finally(() => {
        dispatch({ type: ACTION_INVENTORY_END });
      });
  };

export const maxBulkSelections = () => async (dispatch) => {
  dispatch(
    setToasterMessage({
      toasterMessage: `Maximum allowed inventories for bulk action is ${MAX_BULK_ACTION_ALLOWED}`,
      showToaster: true,
      toasterType: AlertType.WARNING,
    })
  );
};

export const createNextHop =
  (id, params, rawData = {}, callback) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    try {
      await InventoryService.createNextHop(id, params, rawData);
      dispatch(
        setToasterMessage({
          toasterMessage: 'Next hop created successfully',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
      callback();
      dispatch({ type: ACTION_INVENTORY_END });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage:
            e?.response?.data?.message ||
            'Something went wrong, please try again later',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  };

export const directStockIn =
  (aptId, params, rawData = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });

    try {
      await InventoryService.directStockIn(aptId, params, rawData);
      dispatch({
        type: CAR_MOVEMENT,
        payload: 'success',
      });
      dispatch(
        setToasterMessage({
          toasterMessage: 'Stock In done successfully',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
        })
      );
      dispatch({ type: ACTION_INVENTORY_END });
    } catch (e) {
      dispatch({ type: ACTION_INVENTORY_END });
      dispatch(
        setToasterMessage({
          toasterMessage:
            e?.response?.data?.message ||
            'Something went wrong, please try again later',
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  };

export const hardRefreshInventory = (aptId) => async (dispatch) => {
  dispatch(
    setToasterMessage({
      toasterMessage:
        'Inventory details refresh request initiated successfully',
      showToaster: true,
      toasterType: AlertType.SUCCESS,
    })
  );
  try {
    await InventoryService.hardRefreshInventory(aptId);
  } catch (e) {
    console.error(e);
  }
};

export const getInventoryOrderIds = (aptId, params) => async (dispatch) => {
  try {
    let data = await InventoryService.getInventoryOrderIds(aptId, params);
    dispatch({ type: INVENTORY_ORDERS_SUCCESS, payload: data });
  } catch (e) {
    console.trace(e);
  }
};

export const changeParentHub = (params, rawBody, id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    '/apt-' +
    id +
    convertObjectToParams(params);

  try {
    const data = await axiosService.post(url, rawBody);
    dispatch({
      type: CHANGE_PARENT_HUB,
      payload: data.data ? data.data : { message: 'success', params: params },
    });
  } catch (e) {
    dispatch({ type: ACTION_INVENTORY_END });
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const changePlateNumber = (params, rawBody, id) => async (dispatch) => {
  dispatch({ type: ACTION_INVENTORY_START });
  const url =
    config.api.inventory.host +
    config.api.inventory.api_version +
    config.api.inventory.inventory +
    '/apt-' +
    id +
    convertObjectToParams(params);

  try {
    const data = await axiosService.post(url, rawBody);
    dispatch({
      type: CHANGE_NUMBER_PLATE,
      payload: data.data ? data.data : { message: 'success', params: params },
    });
  } catch (e) {
    dispatch({ type: ACTION_INVENTORY_END });
    if (e && e.response && e.response.data && e.response.data.message) {
      dispatch(
        setToasterMessage({
          toasterMessage: e.response.data.message,
          showToaster: true,
          toasterType: AlertType.ERROR,
        })
      );
    }
  }
};

export const handleKeyMovement =
  (payload = { body: {} }) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    return new Promise((resolve, reject) => {
      InventoryService.handleKeyMovement(payload)
        .then((resp) => {
          dispatch(
            setToasterMessage({
              toasterMessage: 'Key status updated successfully',
              showToaster: true,
              toasterType: AlertType.SUCCESS,
            })
          );
          resolve(resp);
        })
        .catch((e) => {
          dispatch({ type: ACTION_INVENTORY_END });
          dispatch(
            setToasterMessage({
              toasterMessage:
                e?.response?.data?.message ||
                'Something went wrong, please try again later',
              showToaster: true,
              toasterType: AlertType.ERROR,
            })
          );
          reject(e);
        });
    });
  };

export const updateSecondKeyStatus =
  (payload = { body: {} }) =>
  async (dispatch) => {
    dispatch({ type: ACTION_INVENTORY_START });
    return new Promise((resolve, reject) => {
      InventoryService.updateSecondKeyStatus(payload)
        .then((resp) => {
          dispatch(
            setToasterMessage({
              toasterMessage: 'Second Key status updated successfully',
              showToaster: true,
              toasterType: AlertType.SUCCESS,
            })
          );
          dispatch({ type: ACTION_INVENTORY_END });
          resolve(resp);
        })
        .catch((e) => {
          dispatch({ type: ACTION_INVENTORY_END });
          dispatch(
            setToasterMessage({
              toasterMessage:
                e?.response?.data?.message ||
                'Something went wrong, please try again later',
              showToaster: true,
              toasterType: AlertType.ERROR,
            })
          );
          reject(e);
        });
    });
  };

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
